import React from 'react';
import ContactForm from '../components/ContactForm';
import {FaLinkedin, FaMailBulk} from 'react-icons/fa';  // Import the LinkedIn icon from react-icons

const Contact = () => (
    <div>
        <h2>Contact Me</h2>
        <p>
            If you have questions or wish to schedule a consultation, please fill out the form below or reach me at:
        </p>
        <p><strong>Email:</strong>
            <a href="mailto:dr.amulyakutikuppala@gmail.com" style={{ marginLeft: '8px'}}>dr.amulyakutikuppala@gmail.com<FaMailBulk style={{ marginLeft: '8px', verticalAlign: '-2' }} />
            </a>
        </p>

        <p><strong>LinkedIn: </strong>
            <a href="https://www.linkedin.com/in/dr-amulya-kutikuppala" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#0077b5' }}>
                Dr. Amulya Kutikuppala <FaLinkedin style={{ marginRight: '8px', verticalAlign: '-2' }} />
            </a>
        </p>


        <ContactForm />
    </div>
);

export default Contact;
